export enum LoginAuthMethod {
  PASSWORD = 'password',
  PASSKEY = 'passkey',
}
